import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, Tag } from "lucide-react";
import { Chapter, Reveal } from "./shared";
import { ARTICLES } from "./blogData";
import { api } from "@/lib/api";
import { fullUrl } from "@/context/SiteConfigContext";

export const Blog = () => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api
      .get("/blog")
      .then((r) => setPosts(r.data.length ? r.data : ARTICLES))
      .catch(() => setPosts(ARTICLES));
  }, []);

  const list = posts || ARTICLES;

  return (
    <section id="dicas" className="bg-white py-24 sm:py-32" data-testid="blog-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Chapter num="09 — Dicas & Blog" title="Conteúdo para deixar sua casa" accent="mais segura" />
        <div className="grid gap-6 md:grid-cols-3">
          {list.map((a, i) => (
            <Reveal key={a.slug || a.title} delay={(i % 3) * 0.12}>
              <article
                data-testid={`blog-card-${i}`}
                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-zinc-200 bg-white transition-[transform,box-shadow] duration-300 hover:-translate-y-2 hover:shadow-[0_24px_50px_-20px_rgba(0,0,0,0.25)]"
              >
                <div className="overflow-hidden">
                  <img
                    src={fullUrl(a.img)}
                    alt={a.title}
                    loading="lazy"
                    className="aspect-[1000/650] w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <div className="flex items-center gap-3 text-[11px] text-zinc-500">
                    <span className="flex items-center gap-1 font-semibold uppercase tracking-wide text-[#E8A200]">
                      <Tag size={11} /> {a.category}
                    </span>
                    <span className="flex items-center gap-1">
                      <CalendarDays size={11} /> {a.date}
                    </span>
                  </div>
                  <h3 className="mt-3 font-display text-lg font-bold uppercase leading-tight text-zinc-900">
                    {a.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-zinc-500">{a.excerpt}</p>
                  <Link
                    to={`/dicas/${a.slug}`}
                    data-testid={`blog-read-${i}`}
                    className="mt-4 inline-flex items-center gap-1.5 self-start font-display text-sm font-bold uppercase tracking-wider text-[#E8A200] transition-colors hover:text-[var(--primary)]"
                  >
                    Ler dica completa
                    <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
